module.exports = __webpack_public_path__ + "static/media/story_poster.011dbe02.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/story_poster.jpeg
// module id = 176
// module chunks = 0